import type { ArticleCardsList } from './article-cards-list'
import type { CarouselContent } from './carousel-content'
import type { CategoriesProps } from './categories'
import type { ContentProps } from './content'
import type { ContentMediaProps } from './content-media'
import type { CountdownProps } from './countdown'
import type { Device } from './device'
import type { EmailCollectorApiProps } from './email-collector'
import type { FaqApiProps } from './faq'
import type { MediaProps } from './media'
import type { PressCarouselContent } from './press-carousel-content'
import type { ProductsBlockApiProps } from './products-block'
import type { RefinedProductsApiProps } from './refined-products'
import type { RichTextProps } from './rich-text-content'
import type { YoutubeVideo } from './video'
import type { VideosContent } from './videos-content'

export const BlockType = {
  Button: 'Button',
  Buttons: 'Buttons',
  // TODO: remove BuyingGuides BlockTyp once naming migration has been completed
  BuyingGuides: 'BuyingGuides',
  ArticleCardsList: 'ArticleCardsList',
  Carousel: 'Carousel',
  Categories: 'Categories',
  Content: 'Content',
  ContentMedia: 'ContentMedia',
  Countdown: 'Countdown',
  EmailCollector: 'EmailCollector',
  EmbeddedYoutubeVideo: 'EmbeddedYoutubeVideo',
  Faq: 'Faq',
  HeroBanner: 'HeroBanner',
  Media: 'Media',
  ModularCardsCarousel: 'ModularCardsCarousel',
  PressCarousel: 'PressCarousel',
  Products: 'Products',
  Quiz: 'Quiz',
  Recommendations: 'Recommendations',
  RefinedProducts: 'RefinedProducts',
  Reinsurance: 'Reinsurance',
  RelatedLinks: 'RelatedLinks',
  RichText: 'RichText',
  VideosBlock: 'VideosBlock',
} as const

export type BlockType = (typeof BlockType)[keyof typeof BlockType]

export type BlockTypeProps =
  | ArticleCardsList
  | CarouselContent
  | VideosContent
  | CategoriesProps
  | ContentProps
  | CountdownProps
  | ContentMediaProps
  | MediaProps
  | EmailCollectorApiProps
  | YoutubeVideo
  | PressCarouselContent
  | RefinedProductsApiProps
  | ProductsBlockApiProps
  | FaqApiProps
  | RichTextProps

export type Block = {
  id: string
  type: BlockType
  hiddenDevices: Device[]
  // Would be better to link "props" to "type" but Vue 3.3 doesn't allow it.
  props: BlockTypeProps
}
